import namedRegexp from 'named-js-regexp';

export const PASSWORD = /^(?=(.*\d){2})(?=(.*[a-zA-Z]){2})[0-9a-zA-Z!@#$%-_]*$/;
export const EMAIL = /.{1,}@.{1,}\..{2,}/;

export const SALARY_NUMBER_SCAN = /^(([0-2]?[0-9]{0,7})([,.][0-9]{1,2})?)$/;
export const SALARY_NUMBER_MASK = /^[0-9]{0,7}([.,][0-9]{0,2})?$/;
export const SALARY_SCAN = /^[0-9]{0,10}$/;
export const SALARY_MASK = /^[0-9]{0,10}$/;
export const CODE = /^[0-9]{0,8}$/;
export const NATURAL_NUMBER = /^[0-9]{1,3}$/;
export const PERCENTS = /^([0-9]{0,2}|100)$/;

export const REQUEST_ERROR = /\w+_ERROR$/g;
export const URL_STATUS = namedRegexp('\\/(:<status>\\w+)$');

export const LINK = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
